'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loginUserThroughGoogle = loginUserThroughGoogle;
exports.loginUser = loginUser;

var _noAuthApiClient = require('../utils/http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _hubspotUrlinator = require('hubspot.urlinator.Url');

var _hubspotUrlinator2 = _interopRequireDefault(_hubspotUrlinator);

var _RouterActions = require('../actions/RouterActions');

var _HubSpotOnlyAppCookieLogin = require('Nabisco/app/HubSpotOnlyAppCookieLogin');

var _HubSpotOnlyAppCookieLogin2 = _interopRequireDefault(_HubSpotOnlyAppCookieLogin);

var _googleLoginNonce = require('../auth/googleLoginNonce');

var _googleLoginNonce2 = _interopRequireDefault(_googleLoginNonce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GOOGLE_LOGIN_ENDPOINT_PATHNAME = '/login-api/v1/google';

function addDefaultOptions(options) {
  return Object.assign({}, {
    rememberLogin: true,
    loginRedirectUrl: (0, _RouterActions.getLoginRedirectUrl)()
  }, options);
}

/* Google login */
var appCookieLogin = new _HubSpotOnlyAppCookieLogin2.default({
  loginRequest: function loginRequest(credentials, lb) {
    var url = new _hubspotUrlinator2.default(GOOGLE_LOGIN_ENDPOINT_PATHNAME, { lb: lb }).href;
    return _noAuthApiClient2.default.post(url, {
      data: credentials
    });
  },
  passThroughFallback: true
});

function loginUserThroughGoogle(_ref) {
  var idToken = _ref.idToken,
      _ref$loginRedirectUrl = _ref.loginRedirectUrl,
      loginRedirectUrl = _ref$loginRedirectUrl === undefined ? (0, _RouterActions.getLoginRedirectUrl)() : _ref$loginRedirectUrl;

  var loginOptions = {
    client: 'HUBSPOT',
    idToken: idToken,
    loginRedirectUrl: loginRedirectUrl,
    nonce: _googleLoginNonce2.default.get()
  };
  return appCookieLogin.login(addDefaultOptions(loginOptions));
}

/* Password login */
var customAppCookieLogin = new _HubSpotOnlyAppCookieLogin2.default({
  passThroughFallback: true
});

function loginUser(_ref2) {
  var email = _ref2.email,
      password = _ref2.password,
      _ref2$loginRedirectUr = _ref2.loginRedirectUrl,
      loginRedirectUrl = _ref2$loginRedirectUr === undefined ? (0, _RouterActions.getLoginRedirectUrl)() : _ref2$loginRedirectUr;

  var loginOptions = { email: email, password: password, loginRedirectUrl: loginRedirectUrl };
  return customAppCookieLogin.login(addDefaultOptions(loginOptions));
}